import { render, staticRenderFns } from "./ocrUpdOther.vue?vue&type=template&id=1fea7768"
import script from "./ocrUpdOther.vue?vue&type=script&lang=js"
export * from "./ocrUpdOther.vue?vue&type=script&lang=js"
import style0 from "./ocrUpdOther.vue?vue&type=style&index=0&id=1fea7768&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports